<template>
    <div
        class="duration-500"
        :class="[{ 'opacity-0': this.isLoading }, { 'opacity-100': ! this.isLoading }]"
    ><view-data-renderer v-if="content" :viewData="content ?? null"></view-data-renderer>
    </div>
</template>

<script>

import ViewDataRenderer from './ViewDataRenderer.vue';

export default {

    name: 'ViewRenderer',

    components: {
        'view-data-renderer': ViewDataRenderer,
    },

    props: ['reference'],

    data() {
        return {
            content: null,
            isLoading: true,
            loader: null,
        }
    },

    created() {

        this.Bus.on('render-view', (data) => {
            if (data.reference === this.reference) {
                this.content = data.content ?? '';
                this.isLoading = false;
                this.hideLoader();

                this.Bus.emit('view-rendered', data.reference);
            }
        });

        this.Bus.on('show-loader', (reference) => {
            if (reference === this.reference) {
                this.showLoader();
            }
        });

        this.Bus.on('hide-loader', (reference) => {
            if (reference === this.reference) {
                this.hideLoader();
            }
        });

        this.createLoader();
    },

    mounted() {

    },

    methods: {

        showLoader() {
            if (this.loader) {
                this.loader.classList.remove('opacity-0');
                this.loader.classList.add('opacity-100');
                this.loader.classList.remove('hidden');
            }
        },

        hideLoader() {

            this.createLoader();

            if (this.loader) {
                this.loader.classList.remove('opacity-100');
                this.loader.classList.add('opacity-0');
                this.loader.classList.add('hidden');
            }
        },

        createLoader() {
            if (! this.loader) {
                this.loader = document.querySelector('.section-loader[data-reference="' + this.reference + '"]');
            }
        },
    },

    computed: {

    }

};
</script>
